import React from "react";
import isEmail from "validator/lib/isEmail";
import { connect } from "react-redux";
import _ from "lodash";
import * as resActions from "../../modules/resources";
import PropTypes from "prop-types";
import { alertSuccess } from "../../utils/alerts";
import QboxmailApi from "../../qboxmailApi";
import withFormState from "Components/withFormState";
import Repeater from "Components/repeater/Repeater";
import Input from "Components/input/Input";
import Button from "Components/button/Button";
import { formatServerErrors } from "Utils/serverFormats";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";
import BackLink from "Components/backLink/BackLink";

import cx from "classnames";

const propTypes = {};

const ContextTypes = {
  router: PropTypes.object,
  isLoggedUserTrial: PropTypes.func,
  getLoggedUser: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
  getLoggedUserType: PropTypes.func,
};

const formInitialState = {
  name: "",
  destinations: [],
};

class AliasEmailNewScreen extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.firstInput.focus();
    this.props.getDomain();
  }

  componentWillUnmount() {
    this.props.resetForm();
  }

  returnToList() {
    const {
      location: { pathname },
    } = this.props;
    let listURL = pathname.split("/").slice(0, -1).join("/");
    this.props.history.push(listURL);
  }

  validate(values) {
    return new Promise((resolve) => {
      let errors = {};
      if (!isEmail(`${values.name}@${this.props.domain.name}`)) {
        errors.name = t("errorMsg.notValid.emailAddress");
      }
      if (values.destinations.length === 0) errors.destinations = t("errorMsg.required");
      if (!values.name) errors.name = t("errorMsg.required");

      const api = new QboxmailApi({ useCookie: true });
      api
        .validateAliasEmailName(this.props.domain.code, values.name)
        .then((response) => {
          if (response.valid) {
            resolve(errors);
          } else {
            errors.name = response.message;
            resolve(errors);
          }
        })
        .catch((errors) => console.error(errors));
    });
  }

  submitForm(e) {
    e.preventDefault();
    this.props.setFormLoading();
    const formData = _.clone(this.props.formData);
    const api = new QboxmailApi({ useCookie: true });

    this.validate(formData).then((errors) => {
      if (Object.keys(errors).length > 0) {
        this.props.setFormErrors(errors);
      } else {
        api
          .createAliasEmail(this.props.domain.code, formData)
          .then(() => {
            this.props.refreshEmailAlias(this.props.domain.code);
            this.props.refreshDomain(this.props.domain.code);
            alertSuccess(t("alert.aliasEmailCreatedSuccess"));
            this.returnToList();
          })
          .catch((response) => {
            formatServerErrors(response).then((errors) => {
              this.props.setFormErrors(errors);
              this.props.unsetFormLoading();
            });
          });
      }
    });
  }

  resetAndGoBack() {
    this.props.resetForm();
    this.returnToList();
  }

  render() {
    const { formData, setFormFieldValue, formErrors, isFormLoading, domain } = this.props;

    return (
      <div>
        <div className="formsPage">
          <div className={cx("sectionTitle", "titleFP")}>{t("emailAccountAlias.add.title")}</div>
          <div className="wrapScrollFP">
            <div className="infoFP">
              <div className="sectionDesc">
                <TranslatedString>emailAccountAlias.add.desc</TranslatedString>
              </div>
              <Button className="btnDocsFP" docsKey="aliasEmailAccounts_add" color="docs" sizeSmall>
                button.docs
              </Button>
            </div>
            <form className="wrapFormsFP" method="post" onSubmit={this.submitForm.bind(this)}>
              <div className="formsFP">
                <Input
                  className="inputFull2"
                  name="name"
                  label={t("input.label.email")}
                  placeholder={t("input.placeholder.email")}
                  required
                  trim
                  ref={(el) => (this.firstInput = el)}
                  value={formData.name}
                  errors={formErrors.name}
                  onChange={setFormFieldValue}
                  blockedTextEnd={"@" + domain.name}
                  autoComplete="new-password"
                />

                <Repeater
                  className="inputFull2"
                  labelInput={t("input.label.add.destination")}
                  label={t("listTable.header.title.destinations")}
                  name="destinations"
                  onChange={setFormFieldValue}
                  values={formData.destinations}
                  errors={formErrors.destinations}
                  validateNewValue={(newVal) => {
                    if (!isEmail(newVal)) {
                      alert(`${newVal} + ${t("errorMsg.notValid.emailAddress")}`);
                      return false;
                    }
                    return true;
                  }}
                  placeholder={t("input.placeholder.myOtherEmail")}
                  helpMsg={t("helpT.add.emailAlias.destinations")}
                />
              </div>
              <div className="footerFP">
                <Button color="text" type="button" onClick={this.resetAndGoBack.bind(this)}>
                  button.cancel
                </Button>
                <Button color="green" type="submit" loading={isFormLoading}>
                  button.create
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

//AliasEmailNewScreen.propTypes = propTypes;
AliasEmailNewScreen.contextTypes = ContextTypes;

const mapStateToProps = (state) => ({
  aliasEmailAccount: resActions.getData("aliasEmailAccount.data", state),
  domain: resActions.getData("domain.data.0", state),
});

const mapDispatchToProps = (dispatch, props) => {
  const domainCode = props.match.params.domainCode || props.loggedUser.domain_code;

  return {
    refreshEmailAlias: (queryParams) =>
      dispatch(resActions.callApi("refreshDomainsAliasEmailAccounts", "alias_email_accounts", queryParams)),
    getDomain: () => dispatch(resActions.callApi("refreshDomain", "domain", domainCode)),
    refreshDomain: () => dispatch(resActions.callApi("refreshDomain", "domain", domainCode)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withFormState(AliasEmailNewScreen, formInitialState));
